import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.browser.api
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.api.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Ce Specialitate Aleg la Rezidentiat 2026"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { info.rezident.app.pages.Landing() }
        ctx.router.register("/admin") { info.rezident.app.pages.Admin() }
        ctx.router.register("/conectare") { info.rezident.app.pages.AuthPage() }
        ctx.router.register("/confidentialitate") { info.rezident.app.pages.PrivacyPolicyPage() }
        ctx.router.register("/contact") { info.rezident.app.pages.ContactPage() }
        ctx.router.register("/profil") { info.rezident.app.pages.MyProfilePage() }
        ctx.router.register("/quiz") { info.rezident.app.pages.QuizPage() }
        ctx.router.register("/raspunsuri") { info.rezident.app.pages.SummaryPage() }
        ctx.router.register("/recomandari") { info.rezident.app.pages.RecommendationsPage() }
        ctx.router.register("/success") { info.rezident.app.pages.SuccessPage() }
        ctx.router.register("/termeni") { info.rezident.app.pages.TermsAndConditionsPage() }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", info.rezident.app.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", info.rezident.app.SubheadlineTextStyle)
        ctx.theme.registerStyle("max-width", info.rezident.app.MaxWidthStyle)
        ctx.theme.registerStyle("header-auth-padding",
                info.rezident.app.pages.headerAuthPaddingStyle)
        ctx.theme.registerStyle("auth-page-layout", info.rezident.app.pages.authPageLayoutStyle)
        ctx.theme.registerStyle("auth-left-panel", info.rezident.app.pages.authLeftPanelStyle)
        ctx.theme.registerStyle("auth-right-panel", info.rezident.app.pages.authRightPanelStyle)
        ctx.theme.registerStyle("auth-form-container",
                info.rezident.app.pages.authFormContainerStyle)
        ctx.theme.registerStyle("contact-text", info.rezident.app.pages.contactTextStyle)
        ctx.theme.registerStyle("contact-section", info.rezident.app.pages.contactSectionStyle)
        ctx.theme.registerStyle("section-padding", info.rezident.app.pages.sectionPaddingStyle)
        ctx.theme.registerStyle("nav-header-height", info.rezident.app.pages.navHeaderHeightStyle)
        ctx.theme.registerStyle("landing-section-padding",
                info.rezident.app.pages.landingSectionPaddingStyle)
        ctx.theme.registerStyle("inner-padding", info.rezident.app.pages.innerPaddingStyle)
        ctx.theme.registerStyle("dynamic-gap", info.rezident.app.pages.dynamicGapStyle)
        ctx.theme.registerStyle("hero", info.rezident.app.pages.heroStyle)
        ctx.theme.registerStyle("hero-img", info.rezident.app.pages.heroImgStyle)
        ctx.theme.registerStyle("hero-text", info.rezident.app.pages.heroTextStyle)
        ctx.theme.registerStyle("hero-spacing", info.rezident.app.pages.heroSpacingStyle)
        ctx.theme.registerStyle("newspaper-item", info.rezident.app.pages.newspaperItemStyle)
        ctx.theme.registerStyle("newspaper-logo", info.rezident.app.pages.newspaperLogoStyle)
        ctx.theme.registerStyle("icon-size", info.rezident.app.pages.iconSizeStyle)
        ctx.theme.registerStyle("how-to-item-padding",
                info.rezident.app.pages.howToItemPaddingStyle)
        ctx.theme.registerStyle("how-to-step", info.rezident.app.pages.howToStepStyle)
        ctx.theme.registerStyle("how-to-step-reversed",
                info.rezident.app.pages.howToStepReversedStyle)
        ctx.theme.registerStyle("how-to-step-column", info.rezident.app.pages.howToStepColumnStyle)
        ctx.theme.registerStyle("how-to-preview-tilt",
                info.rezident.app.pages.howToPreviewTiltStyle)
        ctx.theme.registerStyle("how-to-preview-tilt-reversed",
                info.rezident.app.pages.howToPreviewTiltReversedStyle)
        ctx.theme.registerStyle("social-section-padding",
                info.rezident.app.pages.socialSectionPaddingStyle)
        ctx.theme.registerStyle("social-proof-container",
                info.rezident.app.pages.socialProofContainerStyle)
        ctx.theme.registerStyle("social-proof-item", info.rezident.app.pages.socialProofItemStyle)
        ctx.theme.registerStyle("social-proof-number",
                info.rezident.app.pages.socialProofNumberStyle)
        ctx.theme.registerStyle("news-marquee-spacing",
                info.rezident.app.pages.newsMarqueeSpacingStyle)
        ctx.theme.registerStyle("testimonials-marquee-spacing",
                info.rezident.app.pages.testimonialsMarqueeSpacingStyle)
        ctx.theme.registerStyle("marquee-news-item", info.rezident.app.pages.marqueeNewsItemStyle)
        ctx.theme.registerStyle("marquee-testimonial-item",
                info.rezident.app.pages.marqueeTestimonialItemStyle)
        ctx.theme.registerStyle("marquee", info.rezident.app.pages.marqueeStyle)
        ctx.theme.registerStyle("bottom-cta", info.rezident.app.pages.bottomCtaStyle)
        ctx.theme.registerStyle("button", info.rezident.app.pages.buttonStyle)
        ctx.theme.registerStyle("markdown", info.rezident.app.ui.components.layouts.MarkdownStyle)
        ctx.theme.registerStyle("page-content",
                info.rezident.app.ui.components.layouts.PageContentStyle)
        ctx.theme.registerStyle("footer", info.rezident.app.ui.components.sections.FooterStyle)
        ctx.theme.registerStyle("header-padding",
                info.rezident.app.ui.components.sections.headerPaddingStyle)
        ctx.theme.registerStyle("header-logo",
                info.rezident.app.ui.components.sections.headerLogoStyle)
        ctx.theme.registerStyle("quiz-header-height",
                info.rezident.app.ui.components.sections.quizHeaderHeightStyle)
        ctx.theme.registerStyle("inherit-placeholder-color",
                info.rezident.app.ui.components.widgets.inheritPlaceholderColorStyle)
        ctx.theme.registerStyle("placeholder-color",
                info.rezident.app.ui.components.widgets.placeholderColorStyle)
        ctx.theme.registerStyle("app-typography_title",
                info.rezident.app.ui.theme.AppTypography.title)
        ctx.theme.registerStyle("app-typography_h1", info.rezident.app.ui.theme.AppTypography.h1)
        ctx.theme.registerStyle("app-typography_h2", info.rezident.app.ui.theme.AppTypography.h2)
        ctx.theme.registerStyle("app-typography_body1",
                info.rezident.app.ui.theme.AppTypography.body1)
        ctx.theme.registerStyle("app-typography_body2",
                info.rezident.app.ui.theme.AppTypography.body2)
        ctx.theme.registerStyle("app-typography_body1-medium",
                info.rezident.app.ui.theme.AppTypography.body1Medium)
        ctx.theme.registerVariant("-circle", info.rezident.app.CircleButtonVariant
        )
        ctx.theme.registerVariant("-uncolored", info.rezident.app.UncoloredButtonVariant
        )
        ctx.theme.registerKeyframes("fade", info.rezident.app.pages.fadeAnimation)
        ctx.theme.registerKeyframes("rotation", info.rezident.app.pages.rotationAnimation)
        ctx.theme.registerKeyframes("spin", info.rezident.app.pages.spin)
        ctx.theme.registerKeyframes("fall", info.rezident.app.ui.components.animations.fall)
        ctx.theme.registerKeyframes("side-menu-slide-in",
                info.rezident.app.ui.components.sections.SideMenuSlideInAnim)
        ctx.theme.registerKeyframes("progress-pulse",
                info.rezident.app.ui.components.sections.progressPulseKeyframes)
        ctx.theme.registerKeyframes("slide-up",
                info.rezident.app.ui.components.widgets.slideUpKeyframes)
        ctx.theme.registerKeyframes("slide-down",
                info.rezident.app.ui.components.widgets.slideDownKeyframes)
        ctx.theme.registerKeyframes("fade-in",
                info.rezident.app.ui.components.widgets.fadeInKeyframes)
        ctx.theme.registerKeyframes("fade-out",
                info.rezident.app.ui.components.widgets.fadeOutKeyframes)
        ctx.theme.registerKeyframes("skeleton-pulse",
                info.rezident.app.ui.components.widgets.skeletonPulseKeyframes)
        info.rezident.app.initColorMode(ctx)
        info.rezident.app.initFirebase(ctx)
        info.rezident.app.appInit(ctx)
        info.rezident.app.initSiteStyles(ctx)
        info.rezident.app.ui.theme.initSilkTheme(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)),
            UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "root") {
        info.rezident.app.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
